<template>
    <div class="email-detail-container">
      <!-- 返回按钮 -->
      <button @click="goBack" class="back-button">← 返回列表</button>
      
      <!-- 加载状态 -->
      <div v-if="loading" class="loading">加载中...</div>
      
      <!-- 邮件详情 -->
      <div v-else-if="email" class="email-content">
        <!-- 头部信息 -->
        <div class="email-header">
          <h1 class="subject">{{ email.subject }}</h1>
          <div class="meta-info">
            <span class="sender">发件人: {{ email.sender_name }}</span>
            <span class="date">{{ email.create_time }}</span>
          </div>
        </div>
  
        <!-- 邮件正文 -->
        <div class="email-body" v-html="email.content"></div>
      </div>
  
      <!-- 错误提示 -->
      <div v-else class="error">邮件信息加载失败</div>
    </div>
  </template>
  
  <script>
    import MessageApi from '@/api/message';
  export default {
    name: 'EmailDetail',
    data() {
      return {
        loading: true,
        email: null,
        error: null
      }
    },
    computed: {
      formattedDate() {
        if (!this.email) return ''
        return new Date(this.email.date).toLocaleString()
      }
    },
    created() {
      this.fetchEmailDetail()
    },
    methods: {
      // 模拟API请求
      fetchEmailDetail() {  
        MessageApi.getEmailLogById({ email_log_id: this.$route.query.emailId})
        .then((res) => {
            console.log('邮件详情:', res);
            this.email = res.data;
            this.loading = false
        })
        .catch((err) => {
            console.error('获取邮件详情失败:', err);
            this.$toast.error('获取邮件详情失败');});
      },
  
      goBack() {
        this.$router.go(-1)
      }
    }
  }
  </script>
  
  <style scoped>
  .email-detail-container {
    max-width: 800px;
    margin: 20px auto;
    padding: 30px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0,0,0,0.1);
  }
  
  .back-button {
    background: none;
    border: none;
    color: #666;
    cursor: pointer;
    padding: 10px 0;
    margin-bottom: 20px;
  }
  
  .back-button:hover {
    color: #409eff;
  }
  
  .email-header {
    border-bottom: 1px solid #eee;
    padding-bottom: 20px;
    margin-bottom: 20px;
  }
  
  .subject {
    color: #333;
    margin: 0 0 15px 0;
  }
  
  .meta-info {
    display: flex;
    gap: 20px;
    color: #666;
    font-size: 0.9em;
  }
  
  .email-body {
    line-height: 1.6;
    color: #444;
  }
  
  .loading, .error {
    text-align: center;
    padding: 50px;
    color: #999;
  }
  
  /* 响应式设计 */
  @media (max-width: 768px) {
    .email-detail-container {
      padding: 15px;
      margin: 10px;
    }
    
    .meta-info {
      flex-direction: column;
      gap: 8px;
    }
  }
  </style>


// WEBPACK FOOTER //
// src/views/service/index/emaildetail.vue